import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Checkbox, Tooltip } from 'antd';
import intl from 'react-intl-universal';
import './index.scss';
import { isCNDomain, isJPDomain } from 'Utils/utils';

import { store } from "Store/store.index";

export default class PDFSign extends React.Component {
  constructor(props) {
    super(props);
    let { 
      isDisableFoxitEsignService = false,
      isFlatteDocumentWhenApplyingAllSignatures = false
    } = store.appStore.getPdfSignConfig()
    this.state = {
      isDisableFoxitEsignService,
      isFlatteDocumentWhenApplyingAllSignatures
    }
  }

  setPdfSignConfig() {
    store.appStore.updatePdfSignConfig({
      ...this.state
    });
    store.viewer.pdfui.eventEmitter.emit('changeFoxitEsignVisible', this.state.isDisableFoxitEsignService);
  }

  inkSignChangeHandle = e => {
    this.setState({
      isFlatteDocumentWhenApplyingAllSignatures: e.target.checked
    })
  }

  foxitESignChangeHandle = e => {
    this.setState({
      isDisableFoxitEsignService: e.target.checked
    })
  }


  render() {
    let {  
      isDisableFoxitEsignService,
      isFlatteDocumentWhenApplyingAllSignatures} = this.state;
    const inkSignTitle = intl.formatMessage({ id: 'Preferences.Content.PDFSign.inkSignTitle' });
    const inkSignContent = intl.formatMessage({ id: 'Preferences.Content.PDFSign.inkSignContent' });
    const inkSignTip = intl.formatMessage({ id: 'Preferences.Content.PDFSign.inkSignTip' });
    const foxitESignTitle = intl.formatMessage({ id: 'Preferences.Content.PDFSign.foxitESignTitle' });
    const foxitESignContent = intl.formatMessage({ id: 'Preferences.Content.PDFSign.foxitESignContent' });

    let isShowESign = !isCNDomain() && !isJPDomain() && !store.foxitSignStore.isDisableEsign;

    return (
      <div className="pdfSign-panel">
         <div className="inkSign-container">
          <div className="title signature-title">{inkSignTitle}</div>
          <div className="signature-content">
            <Checkbox checked={isFlatteDocumentWhenApplyingAllSignatures} onChange={this.inkSignChangeHandle}>{inkSignContent}</Checkbox>
            <Tooltip title={inkSignTip}>
              <InfoCircleOutlined style={{fontSize:'13px',color:'#3b99fc'}} />
            </Tooltip>
          </div>
        </div>
        {
          isShowESign && (
            <div className="foxitESign-container">
              <div className="title signature-title">{foxitESignTitle}</div>
              <div className="signature-content">
                <Checkbox checked={isDisableFoxitEsignService} onChange={this.foxitESignChangeHandle}>{foxitESignContent}</Checkbox>
              </div>
            </div>
          )
        }
      </div>
    );
  }
}
